import { isError } from 'flux-standard-action';
import { metaExtractor, payloadExtractor } from 'app-webtech-core/reducers/payloadExtractor';
import { updateState } from 'app-webtech-core/reducers/updateState';
import { LINEAR_CHANNELS_STATE_STATUSES } from '../constants';

const requestMutationGenerator = (payload, { params }) => ({
  params: { $set: params },
  status: { $set: LINEAR_CHANNELS_STATE_STATUSES.PENDING },
  error: { $set: null },
});

const successMutationGenerator = (
  { result, categories, slugs, numbers, entities },
  { params },
) => ({
  params: { $set: params },
  result: { $set: result },
  slugs: { $set: slugs },
  numbers: { $set: numbers },
  entities: { $set: entities },
  categories: { $set: categories },
  lastUpdated: { $set: Date.now() },
  status: { $set: LINEAR_CHANNELS_STATE_STATUSES.DONE },
  error: { $set: null },
});

const errorMutationGenerator = (error, { params }) => ({
  params: { $set: params },
  status: { $set: LINEAR_CHANNELS_STATE_STATUSES.ERROR },
  error: { $set: error },
});

export const linearChannelFetchAllRequestReducer = (currentState, action) =>
  updateState(
    currentState,
    (isError(action) ? errorMutationGenerator : requestMutationGenerator)(
      payloadExtractor(action),
      metaExtractor(action),
    ),
  );

export const linearChannelsFetchAllSuccessReducer = (currentState, action) =>
  updateState(
    currentState,
    (isError(action) ? errorMutationGenerator : successMutationGenerator)(
      payloadExtractor(action),
      metaExtractor(action),
    ),
  );

export const linearChannelsFetchAllFailureReducer = (currentState, action) =>
  updateState(
    currentState,
    errorMutationGenerator(payloadExtractor(action), metaExtractor(action)),
  );
